import { createFeature, createReducer } from '@ngrx/store';

import { jobWorkordersReducers } from './job-workorders.reducer';
import { jobWorkordersInitialState } from './job-workorders.state';

export const jobWorkordersFeature = createFeature({
  name: 'jobV3Workorders',
  reducer: createReducer(jobWorkordersInitialState, ...jobWorkordersReducers),
});
